import React from 'react';
import GameCard from '../../shared/GameCard';

const DefinitionGameCard = () => {
  return (
    <GameCard
      title="Zgadnij słowo z definicji"
      description="Sprawdź swoją znajomość słówek poprzez odgadywanie ich na podstawie definicji."
      imageUrl="/images/definition_game_empty.png"
      imageAlt="Zgadnij słowo z definicji"
      link="/study/definition-game"
    />
  );
};

export default DefinitionGameCard; 